import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const PageHeader = ({ icon: Icon, title, badge, description, iconColor = 'text-primary', iconBg = 'bg-primary/15' }) => {
  const navigate = useNavigate();

  return (
    <header className="relative pt-24 pb-16 lg:pt-32 lg:pb-20 overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full bg-primary/[0.05] blur-[120px]" />
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `linear-gradient(hsl(210 20% 95% / 0.1) 1px, transparent 1px), linear-gradient(90deg, hsl(210 20% 95% / 0.1) 1px, transparent 1px)`,
        backgroundSize: '60px 60px',
      }} />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="mb-8"
        >
          <Button
            variant="glass"
            size="sm"
            onClick={() => navigate('/')}
            className="gap-2"
          >
            <ArrowLeft size={14} />
            Back to Home
          </Button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="flex items-center gap-4 mb-6"
        >
          {Icon && (
            <div className={`w-14 h-14 rounded-2xl ${iconBg} flex items-center justify-center`}>
              <Icon size={26} className={iconColor} />
            </div>
          )}
          {badge && (
            <Badge variant="premium">{badge}</Badge>
          )}
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-5 leading-tight"
        >
          {title}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="text-base lg:text-lg text-muted-foreground font-body leading-relaxed max-w-2xl"
        >
          {description}
        </motion.p>
      </div>
    </header>
  );
};
